"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionPanel = exports.AccordionButton = exports.AccordionItem = exports.Accordion = void 0;
var accordion_1 = require("@reach/accordion");
require("@reach/accordion/styles.css");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var chevron_down_1 = require("../icons/chevron-down");
var mixins_1 = require("../style/mixins");
exports.Accordion = (0, styled_components_1.default)(accordion_1.Accordion)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
exports.AccordionItem = (0, styled_components_1.default)(accordion_1.AccordionItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  background-color: ", ";\n  border-radius: 4px;\n"], ["\n  ", ";\n  background-color: ", ";\n  border-radius: 4px;\n"])), mixins_1.shadow.accordion, function (p) { return p.theme.colors.white; });
var AccordionButton = function (_a) {
    var children = _a.children, _b = _a.hideIcon, hideIcon = _b === void 0 ? false : _b, props = __rest(_a, ["children", "hideIcon"]);
    var _c = (0, react_1.useState)(false), animate = _c[0], setAnimate = _c[1];
    /** stop animation on render */
    (0, react_1.useEffect)(function () {
        setTimeout(function () { return setAnimate(true); }, 100);
    }, []);
    return (react_1.default.createElement(AccordionButtonWrapper, __assign({}, props),
        !hideIcon && react_1.default.createElement(ChevronIcon, { "$animate": animate }),
        children));
};
exports.AccordionButton = AccordionButton;
var AccordionPanel = function (_a) {
    var _b;
    var children = _a.children, props = __rest(_a, ["children"]);
    var _c = (0, react_1.useState)(false), animate = _c[0], setAnimate = _c[1];
    var _d = (0, react_1.useState)(0), maxHeight = _d[0], setMaxHeight = _d[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        setMaxHeight((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0);
    }, [(_b = ref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight]);
    /** stop animation on render */
    (0, react_1.useEffect)(function () {
        setTimeout(function () { return setAnimate(true); }, 100);
    }, []);
    return (react_1.default.createElement(AccordionPanelWrapper, __assign({ ref: ref, "$maxHeight": maxHeight, "$animate": animate }, props), children));
};
exports.AccordionPanel = AccordionPanel;
var AccordionPanelWrapper = (0, styled_components_1.default)(accordion_1.AccordionPanel)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  position: relative;\n\n  display: block; // necessary for animation\n  transition: ", ";\n  max-height: ", "px;\n  [data-reach-accordion-item][data-state=\"collapsed\"] & {\n    max-height: 0;\n  }\n"], ["\n  overflow: hidden;\n  position: relative;\n\n  display: block; // necessary for animation\n  transition: ", ";\n  max-height: ", "px;\n  [data-reach-accordion-item][data-state=\"collapsed\"] & {\n    max-height: 0;\n  }\n"])), function (p) { return p.$animate && "max-height 0.3s linear"; }, function (p) { return p.$maxHeight; });
var AccordionButtonWrapper = (0, styled_components_1.default)(accordion_1.AccordionButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n\n  width: 100%;\n  padding: 18px 24px;\n"], ["\n  ", ";\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n\n  width: 100%;\n  padding: 18px 24px;\n"])), mixins_1.normalizeButton);
var ChevronIcon = (0, styled_components_1.default)(chevron_down_1.ChevronDownM)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n\n  transition: ", ";\n  [data-reach-accordion-item][data-state=\"open\"] & {\n    transform: rotate(-180deg);\n  }\n"], ["\n  color: ", ";\n\n  transition: ", ";\n  [data-reach-accordion-item][data-state=\"open\"] & {\n    transform: rotate(-180deg);\n  }\n"])), function (p) { return p.theme.oldColors.shade[11]; }, function (p) { return p.$animate && "0.2s all linear"; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
